import { useFeatureExperiment, FEATURE_FLAGS } from '../FeaturesAndExperiments';
import { UpgradeModalExperimentGroups } from './enums/experimentGroups';

export enum PaywallModalTypes {
  DEFAULT = 'DEFAULT',
  SINGLE_CLICK_REACTIVATION = 'SINGLE_CLICK_REACTIVATION',
}

export const usePaywallModalTypes = () => {
  const modalVariant: UpgradeModalExperimentGroups = useFeatureExperiment(FEATURE_FLAGS.EXPERIMENT_UPGRADE_MODAL);
  const singleClickReactivationFeatureFlagValue = useFeatureExperiment(FEATURE_FLAGS.SINGLE_CLICK_REACTIVATION);
  const modalType = singleClickReactivationFeatureFlagValue
    ? PaywallModalTypes.SINGLE_CLICK_REACTIVATION
    : PaywallModalTypes.DEFAULT;

  return { modalVariant, modalType };
};
